import React, { useRef, useState } from 'react';

import { ReactComponent as DownArrow } from '../../assets/icons/down-arrow.svg';

/**
 * Custom drop down component
 * @returns
 */
function CustomDropDown({ label, content }: { label: string; content: JSX.Element }) {
  const [isOpen, setIsOpen] = useState(true);
  const contentReference = useRef<HTMLDivElement>(null);
  return (
    <div className="drop-down-wrap">
      <div
        className="drop-down-container"
        onClick={() => setIsOpen((previous) => !previous)}
        role="presentation">
        <div className={`drop-down-arrow ${isOpen ? 'rotate' : ''}`}>
          <DownArrow />
        </div>
        {label}
      </div>
      <div
        className={`drop-down-content ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? contentReference.current?.scrollHeight : 0 }}
        ref={contentReference}>
        <div className="inner-content">{content}</div>
      </div>
    </div>
  );
}

export default CustomDropDown;
